<template>
  <div>
    <h1>{{ $t('lang.title')}}</h1>
    <el-table
    :data="versionTable"
    style="width: 100%"
    default-expand-all>
      <el-table-column
        :label="$t('lang.category')">
        <template scope="scope">
          <span>{{$t(`lang.${scope.row.category}`)}}</span>
        </template>
      </el-table-column>
      <el-table-column type="expand">
      <template scope="categoryProps">
        <el-table
          :data="categoryProps.row.data"
          style="width: 100%">
          <el-table-column type="expand">
            <template scope="props">
              <el-form label-position="left" class="demo-table-expand">
                <el-form-item :label="$t('lang.description')">
                  <br>
                  <span>{{ props.row.desc[$lang] }}</span>
                </el-form-item>
                <el-form-item :label="$t('lang.releaseNote')">
                  <br>
                  <li v-for="item in props.row.releaseNote[$lang]">{{ item }}</li>
                </el-form-item>
              </el-form>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('lang.name')"
            prop="name">
          </el-table-column>
          <el-table-column
            :label="$t('lang.version')"
            prop="version">
          </el-table-column>
          <el-table-column
            :label="$t('lang.updateDate')"
            prop="publishDate">
          </el-table-column>
          <el-table-column
            :label="$t('lang.download')">
            <template scope="props">
              <el-popover
                ref="popover4"
                placement="right"
                width="400"
                trigger="hover"
                v-show="props.row.category === 'software'">
                <li v-for="(v, k) in props.row.url"><a :href="v">{{k}}</a></li>
              </el-popover>
              <el-button v-show="props.row.category === 'software'" v-popover:popover4>{{ $t('lang.download')}}</el-button>
              <el-button v-show="props.row.category !== 'software'" @click="openLink(props.row.url)">{{ $t('lang.download')}}</el-button>
              <el-button @click="historyDialog = true; historyTable=historyInfo[props.row.name]">{{ $t('lang.history')}}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </template>
      </el-table-column>
    </el-table>
    <el-dialog :title="$t('lang.history')" :visible.sync="historyDialog">
      <el-table :data="historyTable">
        <el-table-column property="publishDate" :label="$t('lang.updateDate')" width="150"></el-table-column>
        <el-table-column property="version" :label="$t('lang.version')" width="200"></el-table-column>
        <el-table-column
          :label="$t('lang.download')">
          <template scope="props">
            <el-popover
              ref="popover5"
              placement="right"
              width="400"
              trigger="hover"
              v-show="props.row.category === 'software'">
              <li v-for="(v, k) in props.row.url"><a :href="v">{{k}}</a></li>
            </el-popover>
            <el-button v-show="props.row.category === 'software'" v-popover:popover5>{{ $t('lang.download')}}</el-button>
            <el-button v-show="props.row.category !== 'software'" @click="openLink(props.row.url)">{{ $t('lang.download')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<style>
</style>

<script>
  export default {
    data() {
      return {
        historyDialog: false,
        historyTable: [],
        versionInfo: {},
        historyInfo: {},
        showHistoryInfo: {},
        versionTable: [],
      };
    },
    mounted() {
      this.fetchVersions();
      this.fetchHistory();
    },
    methods: {
      openLink(url) {
        window.open(url);
      },
      fetchVersions() {
        this.$http.get(`/releases/updates.json?v=${Math.random()}`).then((response) => {
          const body = response.data;
          this.versionInfo = {};
          Object.keys(body).forEach((key) => {
            const category = body[key].category;
            if (this.versionInfo[category] === undefined) {
              this.versionInfo[category] = [];
            }
            this.versionInfo[category].push({
              category,
              url: body[key].url,
              version: body[key].version,
              publishDate: body[key].publishDate,
              releaseNote: body[key].releaseNote,
              name: body[key].name,
              desc: body[key].introduction,
            });
          });
          Object.keys(this.versionInfo).forEach((key) => {
            this.versionTable.push({ category: key, data: this.versionInfo[key] });
          });
        }).catch(err => console.log(err));
      },
      fetchHistory() {
        this.$http.get(`/releases/history.json?v=${Math.random()}`).then((response) => {
          Object.keys(response.data).forEach((key) => {
            const versions = response.data[key];
            if (this.historyInfo[key] === undefined) {
              this.historyInfo[key] = [];
            }
            Object.keys(versions).forEach((vk) => {
              this.historyInfo[key].push(versions[vk]);
            });
          });
          console.log(JSON.stringify(this.historyInfo));
        });
      },
    },
  };
</script>



// WEBPACK FOOTER //
// Hello.vue?3a4eb998